let query: URLSearchParams | null = null;

/** True under `pnpm dev` or a `VITE_TEST_SWITCHES=1` build; a literal `false` in production so gated reads drop out. */
export const TEST_SWITCHES: boolean =
  typeof import.meta.env !== 'undefined' && (import.meta.env.DEV || import.meta.env.VITE_TEST_SWITCHES === '1');

/** `?<name>=` off the page's own URL, parsed once at the first read; null with no page (plain Node). */
export function urlParam(name: string): string | null {
  query ??= new URLSearchParams(typeof location === 'undefined' ? '' : location.search);
  return query.get(name);
}

/** Whether the page's URL carries `?<name>=1`. */
export function urlFlag(name: string): boolean {
  return urlParam(name) === '1';
}

/**
 * A test switch read at its first use rather than at module load, written
 * `devFlag(() => TEST_SWITCHES && urlFlag('<name>'))`. The gate stays in the
 * caller's own expression, where a production build folds it to `false` and
 * drops the name; with no page the read never runs.
 */
export function devFlag<T>(read: () => T): () => T | false {
  let value: T | false | undefined;
  return () => (value ??= TEST_SWITCHES && typeof location !== 'undefined' && read());
}
